import getRootResourceWindow from "./getRootResourceWindow";
import Dapi from "./Dapi";
import version from "./version";
import activateDAPINavigation from "./activateDAPINavigation";
import activateDAPIDownload from "./activateDAPIDownload";
import triggerReplaceStateIfAnchorClicked from "./triggerReplaceStateIfAnchorClicked";
import publishContextActions from "./publishContextActions";
import publishAndObserveTitle from "./publishAndObserveTitle";
import observeLocation from "./observeLocation";
import redirectToShell from "./redirectToShell";
/**
 * This file bootstraps the d.velop api (dapi)
 */
if (typeof window.dapi === 'undefined') {
    const rootResourceWindow = getRootResourceWindow(window);
    if (rootResourceWindow != null) {
        let shellDelegate = rootResourceWindow.parent.shell;
        let dapiDelegate = rootResourceWindow.parent.dapi;
        let dapi;
        if (!!shellDelegate) {
            dapi = new Dapi(shellDelegate, toAbsoluteUri, window);
        }
        else if (!!dapiDelegate) {
            dapi = new Dapi(dapiDelegate, toAbsoluteUri, window, false);
        }
        if (shellDelegate) {
            shellDelegate.addUsingResource(window.document.location.href, version);
        }
        activateDAPINavigation(window.document, dapi);
        activateDAPIDownload(window.document, dapi);
        triggerReplaceStateIfAnchorClicked(rootResourceWindow.document, dapi);
        if (window === rootResourceWindow) {
            publishContextActions(window.document.head, dapi);
            publishAndObserveTitle(window.document.querySelector('title'), dapi);
            observeLocation(window, dapi);
        }
        window.dapi = dapi;
        window.Dapi = Dapi;
        window.dapiProxy = dapi.dapiProxy;
    }
    else {
        redirectToShell(window);
    }
}
function toAbsoluteUri(uri) {
    const anchorElement = document.createElement('a');
    anchorElement.href = uri; // now href is an absolute uri.
    return anchorElement.href;
}
